export const technicalReportInfo = {
  actorList: { title: "Aktorliste", description: "Gerätedaten, physikalische Adressen und Anschlussbelegung der Aktoren" },
  cabinetParts: { title: "Schaltschrank-Stückliste", description: "Geräte, Schutzgeräte, Klemmen, Platzbedarf und Busstrom" },
  cablePull: { title: "Kabelzugliste", description: "Leitungen und Ziele je Raum, einschließlich Raumgeräte" },
  // Vorläufig aus Dokumentauswahl und Export genommen:
  // cableRouting: { title: "Kabelroutingliste", description: "Verbraucher und zugehörige Anschlussklemmen" },
  // Vorläufig aus Dokumentauswahl und Export genommen:
  // cableWires: { title: "Kabeltypen und Aderbelegung", description: "Leitungstypen, Adern und nachgeordnete Verbraucher" },
  consumerConnections: { title: "Verbraucherliste", description: "Funktionen, Aktorkanäle, Klemmen, Sicherungen und Kabel" },
  // Vorläufig aus Dokumentauswahl und Export genommen:
  // deviceTemplates: { title: "Geräte-Template-Liste", description: "Verwendete Produkte mit Geräten, Platzbedarf und Busstrom" },
  multiplexers: { title: "Multiplexerliste", description: "Multiplexer mit Tasten und Verbrauchern" },
  projectStatistics: { title: "Projektstatistik", description: "Objektzahlen, Verknüpfungen und Busstrom" },
  scenes: { title: "Szenenliste", description: "Szenen, Auslöser, Verbraucher und konfigurierte Werte" },
  productPrices: { title: "KNX-Geräte Preisliste", description: "Gespeicherte Produktpreise mit Mengen und Summen" },
  terminals: { title: "Klemmenpläne", description: "SVG-Klemmenpläne mit Brücken, Adern und Verbrauchern" },
} as const;
export type TechnicalReportId = keyof typeof technicalReportInfo;

/** Recognizes main-app chapters implemented by the shared technical list renderer. */
export function isTechnicalReportId(id: string): id is TechnicalReportId {
  return Object.prototype.hasOwnProperty.call(technicalReportInfo, id);
}
